<template>
    <div id="components-main-layout" v-if="check">
        <a-layout :style="{ zIndex: 1, height: '100%' }">
            <menu_sidebar :current="current" :openKeys="openKeys">这里是sidebar</menu_sidebar>
            <a-layout>
                <header_bar>这里是header</header_bar>
                <a-layout-content :style="{padding:'0 20px'}">
                    <div :style="{marginTop:'10px',}">
                        <a-breadcrumb>
                            <a-breadcrumb-item>首页</a-breadcrumb-item>
                            <a-breadcrumb-item>站点概况</a-breadcrumb-item>
                        </a-breadcrumb>
                    </div>
                    <router-view />
                </a-layout-content>
                <footer_bar>这里是footer</footer_bar>
            </a-layout>
        </a-layout>
    </div>
</template>

<script>
    import menu_sidebar from '../components/menu_sidebar'
    import header_bar from '../components/header'
    import footer_bar from '../components/footer'
    import axios from 'axios'
    import Cookies from "js-cookie";
export default {
    name: "Home",
    components:{
        menu_sidebar,
        header_bar,
        footer_bar,
    },
    data(){
        return {
            current: ['1'],
            openKeys: ['1'],
            check:false,
            json_data:{},
        };
    },
    mounted() {
        this.json_data.token = Cookies.get("Token");
    },
    beforeCreate() {
        var token = Cookies.get('Token');
        var json_data = '{"action":"CheckToken","token":"'+token+'"}';
        let self = this;
        axios.post('/api/index.php',json_data)
            .then((response)=> {
                if(response.data.status!=1){
                    self.$router.push({path:'/login'})
                }else{
                    this.check = true;
                }
            })
            .catch(function (error) { // 请求失败处理
                console.log(error);
            });
        this.$store.commit("sidebar_current", ['1'])
        this.$store.commit("sidebar_openKeys", ['1'])
    },
    computed:{
        collapsed(){
            return this.$store.state.collapsed
        }
    },
    methods:{

    }
}
</script>

<style scoped>
#components-main-layout{height:100%;width:100%;}
#components-main-layout {
    /*text-align: center;*/
}

#components-main-layout .ant-layout-sider {
    background: #E9EEF3;
    color: #fff;
    line-height: 120px;
}
#components-main-layout .ant-layout-content {
    background: #E9EEF3;
    color: #fff;
    min-height: 120px;
    line-height: 120px;
}
#components-main-layout > .ant-layout {
    margin-bottom: 48px;
}
#components-main-layout > .ant-layout:last-child {
    margin: 0;
}
</style>